import initialState from './initialState';
import { LoadingStatusEnum } from '../../../constants/enums';

export const GetConveyorTemplatesReducer = {
  pending: (state) => ({
    ...state,
    loading: 'pending',
  }),
  fulfilled: (state, action) => {
    const { data } = action.payload;

    return {
      ...state,
      list: data || [],
      loading: 'succeeded',
    };
  },
  rejected: (state) => ({
    ...state,
    loading: 'failed',
  }),
};

export const GetConveyorTemplateByIdReducer = {
  pending: (state) => ({
    ...state,
    selectedItem: {
      ...state.selectedItem,
      loading: 'pending',
    },
    loading: 'pending',
  }),
  fulfilled: (state, action) => {
    const { data } = action.payload;

    return {
      ...state,
      selectedItem: {
        data,
        loading: 'succeeded',
      },
      loading: 'succeeded',
    };
  },
  rejected: (state) => ({
    ...state,
    selectedItem: {
      ...state.selectedItem,
      loading: 'failed',
    },
    loading: 'failed',
  }),
};

export const GetConveyorStepTemplateByIdReducer = {
  pending: (state) => ({
    ...state,
    selectedStepTemplate: {
      ...state.selectedStepTemplate,
      loading: 'pending',
    },
    loading: 'pending',
  }),
  fulfilled: (state, action) => {
    const { data } = action.payload;

    return {
      ...state,
      selectedStepTemplate: {
        data,
        loading: 'succeeded',
      },
      loading: 'succeeded',
    };
  },
  rejected: (state) => ({
    ...state,
    selectedStepTemplate: {
      ...state.selectedStepTemplate,
      loading: 'failed',
    },
    loading: 'failed',
  }),
};

export const UpdateConveyorTemplateReducer = {
  pending: (state) => ({
    ...state,
    selectedItem: {
      ...state.selectedItem,
      loading: 'pending',
    },
    loading: 'pending',
  }),
  fulfilled: (state, action) => {
    const { data } = action.payload;

    return {
      ...state,
      selectedItem: {
        data,
        loading: 'succeeded',
      },
      list: state.list.map((item) => {
        if (item._id === data._id) {
          return data;
        }

        return item;
      }),
      loading: 'succeeded',
    };
  },
  rejected: (state) => ({
    ...state,
    selectedItem: {
      ...state.selectedItem,
      loading: 'failed',
    },
    loading: 'failed',
  }),
};

export const ClearSelectedConveyorTemplateReducer = (state) => ({
  ...state,
  selectedItem: {
    data: null,
    loading: 'idle',
  },
});

export const ClearSelectedConveyorStepTemplateReducer = (state) => ({
  ...state,
  selectedStepTemplate: {
    data: null,
    loading: 'idle',
  },
});

export const ResetConveyorTemplatesReducer = () => initialState;

export const UpdateConveyorStepTemplateReducer = {
  pending: (state) => ({
    ...state,
    selectedStepTemplate: {
      data: null,
      loading: 'pending',
    },
    loading: 'pending',
  }),
  fulfilled: (state, action) => {
    const { data } = action.payload;

    return {
      ...state,
      selectedStepTemplate: {
        data,
        loading: 'succeeded',
      },
      loading: 'succeeded',
    };
  },
  rejected: (state) => ({
    ...state,
    selectedStepTemplate: {
      ...state.selectedStepTemplate,
      loading: 'failed',
    },
    loading: 'failed',
  }),
};

export const ChangeConveyorStepTemplateInactiveStatusReducer = {
  pending: (state) => ({
    ...state,
    loading: LoadingStatusEnum.Pending,
  }),
  fulfilled: (state, action) => {
    const { list } = state;
    const conveyorSteps = action.payload.data;
    const updatedList = list.map((item) => {
      if (item._id === conveyorSteps._id) {
        return conveyorSteps;
      }
      return item;
    });
    return {
      ...state,
      list: updatedList,
      loading: LoadingStatusEnum.Succeeded,
    };
  },
  rejected: (state) => ({
    ...state,
    loading: LoadingStatusEnum.Failed,
  }),
};

export const ChangeConveyorTemplateInactiveStatusReducer = {
  pending: (state) => ({
    ...state,
    loading: LoadingStatusEnum.Pending,
  }),
  fulfilled: (state, action) => {
    const updatedTemplate = action.payload.data;
    const updatedList = state.list.map((item) => {
      if (item._id === updatedTemplate._id) {
        return updatedTemplate;
      }
      return item;
    });

    return {
      ...state,
      list: updatedList,
      selectedItem: {
        ...state.selectedItem,
        data: state.selectedItem.data?._id === updatedTemplate._id ? updatedTemplate : state.selectedItem.data,
      },
      loading: LoadingStatusEnum.Succeeded,
    };
  },
  rejected: (state) => ({
    ...state,
    loading: LoadingStatusEnum.Failed,
  }),
};

export const GetFactoryIconsReducer = {
  pending: (state) => ({
    ...state,
    icons: {
      ...state.icons,
      loading: LoadingStatusEnum.Pending,
    },
  }),
  fulfilled: (state, action) => {
    const icons = action.payload.data;
    return {
      ...state,
      icons: {
        data: icons?.split(',') || [],
        loading: LoadingStatusEnum.Pending,
      },
    };
  },
  rejected: (state) => ({
    icons: {
      ...state.icons,
      loading: LoadingStatusEnum.Failed,
    },
  }),
};
